export default __webpack_public_path__ + "static/media/azerchay.243cec1f.png";